

<template>

<v-container style="min-height: 100%; min-width: 100%;padding-top:2px;">
    <v-row align="start" width="100%">
        <NavBar test="Home"></NavBar>
    </v-row>
    <v-row style="height: 100vh;">
        <v-col class="pa-1" cols="3" style="height: calc(100vh - 48px);">
            <v-card style="height: 100vh;">
                <v-navigation-drawer style="height: 100vh;" permanent width="100%">
                    <v-list>
                        <v-list-item link>
                            <v-list-item-content>
                                <v-list-item-title class="title">{{name}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list rounded>
                        <v-list-item-group v-model="item" color="primary">
                            <v-list-item @click="goto(2)">
                                <v-list-item-icon>
                                    <v-icon>person</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Users</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="goto(0)">
                                <v-list-item-icon>
                                    <v-icon>place</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Locations</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="goto(1)">
                                <v-list-item-icon>
                                    <v-icon>supervisor_account</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Suppliers</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="goto(3)">
                                <v-list-item-icon>
                                    <v-icon>cloud_upload</v-icon>
                                </v-list-item-icon>
                                <v-list-item-title>Upload Inventory</v-list-item-title>
                            </v-list-item>

                        </v-list-item-group>
                    </v-list>
                </v-navigation-drawer>
            </v-card>
        </v-col>
        <v-col class="pa-1" cols="9" style="height: calc(100vh - 48px);">
            <v-card style="height: 100%; overflow-y: auto; overflow-x: hidden">
                <router-view></router-view>
            </v-card>
        </v-col>
    </v-row>
</v-container>

</template>

<script>

import NavBar from '../NavBar.vue'

export default {
    components: {
        NavBar
    },
    created() {
        this.name = this.$store.state.token.name;
    },
    data: () => ({
        isLoading: false,
        name: null,
        item: null
    }),
    methods: {
        goto(index) {
                switch (index) {
                    case 0:
                        this.$router.push('/admin/locations');
                        break;
                    case 1:
                        this.$router.push('/admin/suppliers');
                        break;
                        // case 6:
                        //     this.$router.push('/inventory/programmers');
                        //     break;
                    case 2:
                        this.$router.push('/admin/users');
                        break;
                    case 3:
                        this.$router.push('/admin/upload')
                        break;
                }
            },
            shouldShowInventoryRelated() {
                return this.$store.state.isManager || this.$store.state.isAdmin;
            },


    }
}

</script>
